'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.monthsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/monthsFromNow.js
// module id = 578
// module chunks = 0